// extracted by mini-css-extract-plugin
export default {"menu":"HamburgerMenu_menu__DYpRu","menuCollapsed":"HamburgerMenu_menuCollapsed__rHHSc","menuToggle":"HamburgerMenu_menuToggle__xj-HC","menuLinks":"HamburgerMenu_menuLinks__NcmS+"};